import "./_atoms/crossfade/crossfade";
import ScrollGrow from "./_atoms/scroll-grow/scroll-grow";
import "./_components/countup/countup.ts";
import "./_components/customer-journey/customer-journey";
import "./_components/customer-journey/customer-journey-timeline";
import "./_components/hero/hero.ts";
import HotSpot from "./_components/hotspot/hotspot";
import "./_components/illu/illu.ts";
import "./_components/img-zoom/img-zoom";
import "./_components/lottie/lottie.ts";
import "./_components/navigation/navigation.ts";
import PinSection from "./_components/scroll-pin-section/scroll-pin-section.ts";
import "./_components/scroll-pin/scroll-pin.ts";
import "./_components/scroll-reveal/scroll-reveal.ts";
import "./_components/slider/slider.ts";
import "./_components/schematic/schematic.ts";
import "./_components/type/type";
import "./_components/wipe-reveal/wipe-reveal";
import "./_components/slide-reveal/slide-reveal";
import "./_atoms/animation/animation.ts";

const scrollgrow = new ScrollGrow();
const hotspot = new HotSpot();
const pinsection = new PinSection();
